import { useEffect, useState } from "react"
import { Link } from "@remix-run/react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "~/components/ui/dialog"

const STORAGE_KEY = "promoPopupSeen"

export default function PromoPopup() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return
    const timer = setTimeout(() => setOpen(true), 500)
    return () => clearTimeout(timer)
  }, [])

  function dismiss() {
    sessionStorage.setItem(STORAGE_KEY, "1")
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(value) => {
        if (!value) dismiss()
      }}>
      <DialogContent
        className="max-w-md mx-4 sm:mx-auto text-center"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader className="sm:text-center">
          <DialogTitle className="text-2xl sm:text-3xl">
            Get Hot This Summer ❤️‍🔥
          </DialogTitle>
          <DialogDescription className="text-base text-foreground/80 mt-2">
            Get 10 free credits when you upgrade to an annual subscription!
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">Offer ends 7/5.</p>
        <Link
          to="/subscribe"
          onClick={dismiss}
          className="inline-block w-full rounded-md bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground hover:bg-primary-dark transition-colors">
          Buy Now
        </Link>
      </DialogContent>
    </Dialog>
  )
}
